import { Instagram, Twitter, Facebook } from "lucide-react";
import { scrollToId } from "@/components/site/Reveal";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-noir text-beige">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="leading-none">
              <span className="block font-display text-3xl font-extrabold uppercase tracking-tight">Protein<span className="text-amber-brand">Cafe</span></span>
              <span className="block text-[11px] uppercase tracking-[0.3em] text-beige/50 mt-2">The Fuel Lounge&trade;</span>
            </div>
            <p className="mt-4 max-w-sm text-beige/70 leading-relaxed">Fuel your fitness journey with scientifically formulated nutrition — every macro, fully transparent.</p>
            <div className="mt-6 flex gap-3">
              {[Instagram, Twitter, Facebook].map((Icon, i) => (
                <a key={i} href="#contact" onClick={(e) => { e.preventDefault(); scrollToId("contact"); }} className="grid place-items-center w-10 h-10 rounded-full border border-white/15 hover:bg-[#8A2231] hover:border-[#8A2231] transition-colors">
                  <Icon size={17} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-display text-lg font-bold mb-4">Explore</h4>
            <ul className="space-y-2.5 text-beige/70 text-sm">
              {[["Menu", "menu"], ["Builder", "builder"], ["Vending", "vending"], ["Services", "services"]].map(([l, id]) => (
                <li key={id}><button onClick={() => scrollToId(id)} className="hover:text-amber-brand transition-colors">{l}</button></li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-display text-lg font-bold mb-4">Company</h4>
            <ul className="space-y-2.5 text-beige/70 text-sm">
              {[["About", "about"], ["Contact", "contact"], ["Community", "services"]].map(([l, id]) => (
                <li key={l}><button onClick={() => scrollToId(id)} className="hover:text-amber-brand transition-colors">{l}</button></li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-coffee-soft flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-beige/60">
          <p>© {new Date().getFullYear()} ProteinCafe. Stay Fueled™ · FSSAI Lic. No. 21221188000463</p>
          <p className="font-mono">Fuel Your Fitness Journey</p>
        </div>
      </div>
    </footer>
  );
}
